var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlaggedComment = function SvgFlaggedComment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95959A",
    fillRule: "evenodd",
    d: "M1.25.688c.31 0 .563.251.563.562v.405L3.19 1.31a7.313 7.313 0 0 1 5.044.554l.08.04a6.187 6.187 0 0 0 4.185.489l2.332-.549a.563.563 0 0 1 .688.608 35.845 35.845 0 0 0 .004 7.753.562.562 0 0 1-.43.608l-2.336.55a7.313 7.313 0 0 1-4.945-.578l-.081-.04a6.188 6.188 0 0 0-4.268-.469l-1.651.413v4.061a.562.562 0 1 1-1.125 0V1.25c0-.31.251-.562.562-.562Z",
    clipRule: "evenodd"
  })));
};
export default SvgFlaggedComment;